import React from 'react';
import { Routes, Route, Navigate, useParams  } from 'react-router-dom';
import ClientDashboard from '../components/ClientModule/ClientDashboard';
import ReportPage from '../components/ClientModule/Report';

const ReportPageWrapper = () => {
  const { candidateId } = useParams();
  return <ReportPage candidateId={candidateId} />;
};

const ClientRoutes = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="dashboard" />} />
      <Route path="dashboard" element={<ClientDashboard />} />
     <Route path="reportpage/:candidateId" element={<ReportPageWrapper />} />
    </Routes>
  );
};

export default ClientRoutes;
